import { Box, Button, Container, Grid, Paper, TextField } from "@mui/material"
import React, { useEffect, useRef, useState } from "react"
import BarcodeList, { BarcodeOriginal } from "../components/Reactbarcode"
import CenterModal from "../components/Modal"
import Modal from "react-bootstrap/Modal"
import { toast } from "react-toastify"
import apiClient from "../api/apiClient"
import CircularProgress from "@mui/material/CircularProgress"
import Paginate from "../components/mui/Paginate"
import { Helmet } from "react-helmet"
import jsPDF from "jspdf"
import JSZip from "jszip"
import { saveAs } from "file-saver"
import html2canvas from "html2canvas"
import html2pdf from "html2pdf.js"
import TabBars from "../components/mui/TabBars"
import PropTypes from "prop-types"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Typography from "@mui/material/Typography"
import SelectOption from "../components/mui/SelectOption"
import LoadingOverlay from "../components/mui/LoadingOverlay"
import { BarcodeFilterSidebar } from "../components/sidebar-filter/ProductFilterSidebar"
import { objectToQueryString } from "../modules/helpers"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import BarcodeListArchive from "../components/BarcodeArchiveAdmin"
import moment from "moment"
import BarcodesExportMenu from "../components/barcode/BarcodesExportMenu"
import { useDispatch } from "react-redux"
import { showModal } from "../redux/modalSlice"
import { useSearchParams } from "react-router-dom"

let limit = 12

export default function Barcode() {
  const [searchParams, setSearchParams] = useSearchParams()
  const urlPage = parseInt(searchParams.get("page")) || 1
  const [count, setCount] = useState(0)
  const [load, setLoad] = useState(false)
  const [barcodeValues, setBarcodeValues] = useState()
  const [page, setPage] = useState(urlPage)
  const [barcodeType, setType] = useState(searchParams.get("key") || "")
  const [showFilter, setShowFilter] = useState(false)
  const [date, setDate] = useState([])
  const [reset, setReset] = useState(false)
  const [modalShow, setModalShow] = useState(false)
    const dispatch = useDispatch()
      const [showNotesModal, setShowNotesModal] = useState(false)
      const [showModalViewNotes, setShowModalViewNotes] = useState(false)

      const [notesMDLData,setNotesMDLData]=useState("")
  const intialFilters = {
    barcode: searchParams.get("barcode") || "",
    status: searchParams.get("status") || "",
    code_disabled:""
  }
  const [filters, setFilters] = useState(intialFilters)
  const onReset = () => {
    setFilters({ barcode: "", status: "", code_disabled: "" })
    setPage(1)
    setSearchParams({})
    setReset(true)
  }
  const onFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value })
  }
  useEffect(() => {
    if (reset) fetchdata()
  }, [reset])
  useEffect(() => {
    fetchdata(page)
  }, [barcodeType])





  const fetchdata = async (currentPage = page) => {
    if (currentPage == 1 && count) setCount(0)
    setLoad(true)

    const filtersObj = buildFiltersObj(filters)
    const params = new URLSearchParams()
    if (barcodeType) params.set("key", barcodeType)
    if (filters.barcode) params.set("barcode", filters.barcode)
    if (filters.status) params.set("status", filters.status)
    if (currentPage > 1) params.set("page", currentPage)
    setSearchParams(params)
    setPage(currentPage)

    const result = await apiClient.get(
      `/qr/?limit=${limit}&page=${currentPage}&archive=true&key=${barcodeType}&${objectToQueryString(
        filtersObj
      )}`
    )
    setLoad(false)
    if (!result.ok) return toast.error("Error")
    if (!count || currentPage == 1 || count !== result.data.count) setCount(result.data.count)
    //console.log(result.data,"lllllll");
    setBarcodeValues(result.data.results)
  }



  function buildFiltersObj(filters) {
  const { status, ...rest } = filters;
  switch (status) {
    case "disabled":
      return { ...rest, code_disabled: true, activated: "" };
    case "activated":
      return { ...rest, activated: true, code_disabled: false };
    case "not-activated":
      return { ...rest, activated: false, code_disabled: false };
    default:
      return { ...rest, activated: "", code_disabled: "" };
  }
}

  const handlePageChange = (event, value) => {
    fetchdata(value)
  }

  const baseUrl = "www.gphtest.com"





const handleBarcodeDisableToggle=async(id)=>{

  const result = await apiClient.patch(`/qr/toggle-enable-code/${id}`, )
  setLoad(false)
  if (!result.ok)
    return dispatch(
      showModal({
        error: true,
        title: "Sample",
        message: result.data.message
      })
    )
  fetchdata()
  return dispatch(
    showModal({
      error: false,
      title: "Barcode Access Toggle",
      message: result.data.message
    })
  )
}






  return (
    <div>
      <Helmet>
        <title>Barcode</title>
      </Helmet>
      <Container className="" maxWidth="lg">
        <div className="d-flex justify-content-center ">
          <Grid md={9} xs={12} container sx={{ marginTop: 5, borderRadius: 10 }}>
            <Grid className="p-3 row justify-content-between" item xs={12}>
              <div className="d-flex justify-content-between align-items-center flex-column flex-sm-row">
                <h3>Archives</h3>
                <Button
                  sx={{ borderRadius: 20, fontSize: 10 }}
                  onClick={() => setModalShow(true)}
                  className="btn_bg_secondery px-2 "
                  variant="contained">
                  Generate New Barcodes
                </Button>
                <CenterModal
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                  fetchData={onReset}
                />
              </div>
            </Grid>
          </Grid>
        </div>

        {load ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : (
          <div className="d-flex justify-content-center ">
            <Grid
              md={9}
              xs={12}
              container
              className="shadow"
              sx={{ marginTop: 5, borderRadius: 10 }}>
              <Grid className="p-3 row justify-content-between" item xs={12}>
                <div className="col">
                  <BarcodeFilterSidebar
                    openFilter={showFilter}
                    onOpenFilter={() => setShowFilter(true)}
                    onCloseFilter={() => setShowFilter(false)}
                    handleChange={onFilterChange}
                    values={filters}
                    onReset={onReset}
                    fetchData={() => fetchdata(1)}
                  />
                </div>
                <div className="col-4">
                  <SelectOption
                    style={{ width: "100%" }}
                    size="small"
                    data={[
                      { value: "!pp", label: "Normal" },
                      { value: "pp", label: "PP Barcodes" },
                      { value: "exp", label: "EXP Barcodes" }
                    ]}
                    id="outlined-basic"
                    value={barcodeType}
                    onChange={e => {
                      setPage(1)
                      setType(e.target.value)
                      console.log(e.target.value)
                    }}
                    label="Barcode Type"
                    variant="outlined"
                  />
                </div>
              </Grid>

              {barcodeValues?.map(value => (
                <Grid
                  className=""
                  item
                  md={4}
                  sm={6}
                  xs={12}
                  spacing={5}
                  sx={{ marginTop: 3, padding: 2 }}>
                  <BarcodeListArchive
                    url={baseUrl}
                    itemObj={value}
                    ShowiIcon={true}
                    handleBarcodeDisableToggle={() => handleBarcodeDisableToggle(value._id)}
                    handleAddNotes={() => {
                      setNotesMDLData(value)
                      setShowNotesModal(true)
                    }}
                    handleViewNotes={() => {
                      setNotesMDLData(value)
                      setShowModalViewNotes(true)
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        )}
        <div className={`${load && "d-none "}   d-flex justify-content-center `}>
          <Paginate
            className="btn_bg"
            color="primary"
            style={{ color: "white" }}
            count={count}
            limit={limit}
            page={page}
            onChange={handlePageChange}
          />
        </div>

        {showNotesModal && (
          <NotesModal
            show={showNotesModal}
            onHide={() => {
              setShowNotesModal(false)
              setNotesMDLData("")
            }}
            data={notesMDLData}
            // fetchData={fetchData}
            // data={data}
          />
        )}

        {showModalViewNotes && (
          <NotesViewModal
            show={showModalViewNotes}
            onHide={() => {
              setShowModalViewNotes(false)
              setNotesMDLData("")
            }}
            data={notesMDLData}
            // fetchData={fetchData}
            // data={data}
          />
        )}
      </Container>
    </div>
  )
}






function NotesModal({ data, onHide, show }) {

  let initialstate = {
    notes: data.notes || ""
  }
  const dispatch = useDispatch()
  const [formData, setFormData] = useState(initialstate)
  const handleChange = (key, value) => {
    setFormData({ ...formData, [key]: value })
  }
  const handleSubmit = async e => {
    e.preventDefault()
    const result = await apiClient.patch(`/qr/notes/${data.key}/`, formData)
    if (!result.ok)
      return dispatch(
        showModal({
          error: true,
          title: "Notes",
          message: result.data.message
        })
      )
    onHide()
    return dispatch(
      showModal({
        error: false,
        title: "Notes Added"
        // message: result.data.message
      })
    )
  }
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header className=" " closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="text-center w-100">
          <h4 className="text-center">Barcode Notes</h4>
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          {/* <h4 className="text-center">Order Notes</h4> */}

          <div className="row justify-content-center gap-2 my-2">
            <div className="col-12">
              <TextField
                // required
                label="Notes For Barcode"
                // value={client.veterinarian}
                name="notes"
                value={formData.notes}
                onChange={e => handleChange("notes", e.target.value)}
                variant="outlined"
                fullWidth
                multiline
                rows={5}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button 
            type="submit"
            size="large"
            // onClick={()=>handleSubmit()}
            variant="contained"
            className=" btn_bg_secondery px-5">
            Save
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}


function NotesViewModal({ data, onHide, show }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="text-center w-100">
          <h4 className="text-center m-0">Barcode Notes</h4>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row justify-content-center gap-2 my-2">
          <div className="col-12">
            {/* Display the notes or a fallback message */}
            <div 
              className="p-3 border rounded bg-light" 
              style={{ whiteSpace: "pre-wrap", minHeight: "100px" }}
            >
              {data?.notes ? data.notes : "No notes available."}
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center">
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
